import { IPlanContent } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  defaultKeyDetails,
  defaultEstimatesDialog,
  gasKeyDetailsAddons,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

export const originValueBuilder: IPlanContent = {
  test: createPlanNameMatcher(['Origin Value Builder']),
  content: {
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {},
    estimatesDialog: defaultEstimatesDialog({ customerType: 'residential' }),
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-value-builder/',
      },
    },
  },
};
